import HTTP from "./http.service";
import Plans from "./plans.service";
import Products from "./products.service";
import Storage from "./storage.service";
import User from "./user.service";
import * as variables from "../variables";
import Helpers from "../helpers/shared.helper";
import STF_CONSTANTS from "./stfConstant.service";
import checkModule from "../views/shared/checkModule";

var planFG = {};
const {isPlanKw } = checkModule
planFG.fetchCommitment = () => {
    let config = {
        method: "get",
        // url: "products/available?productAttribute=Regular"
        url: "/products/get_products_by_category?productAttribute=Regular5G"
    };
    return HTTP(config);
};
planFG.getPlanDataValue = (plan, type, dataValue = true) => {
    let value = "";
    if (plan?.length) {
        plan.forEach((data) => {
            if (data?.Type === type) {
                if (dataValue) {
                    value = data?.Value !== -1
                        ? Helpers.bytesToGBs(data?.Value)
                        : 0;
                } else {
                    value = data?.PlanID.toString();
                }

            }

        })
    }
    return value;

}
planFG.getPredeinedFGplan = (product_code) => {
    let offerAppliedPromoId = Storage.get("offer_applied_promotion_id", true);
    let config = {
        method: "get",
        url: "/products/predefined_bundles?include_optional_promotions=true&product_codes=" + product_code
    };

    if (offerAppliedPromoId && offerAppliedPromoId.length) {
        // let promotionID = "";
        // promotionID = offerAppliedPromoId.join(",");
        config = {
            method: "get",
            url: "/products/predefined_bundles?include_optional_promotions=1&product_codes=" +
                product_code + "&promotion_codes=" + offerAppliedPromoId
        };
    }

    return HTTP(config);
};

planFG.saveFGplan = (data, streamingPromotionCode = null) => {
    return new Promise(async (resolve) => {
        const response = await Products.saveProduct(data?.product_code);
        if (response) {
            const result = await planFG.saveFGplanData(data, streamingPromotionCode);
            if (result) {
                setTimeout(() => {
                    User.fetchFlowStatus().then(() => {
                        resolve(true)
                    }).catch(() => {
                        resolve(false)
                    })
                }, 2000);
            } else {
                resolve(false)
            }
        } else {
            resolve(false)
        }
    })
};

planFG.savehomePlan = (storage_params, planData) => {
    Storage.set("wp_loader", true);
    let fgProductCode = storage_params["fg_product_code"];
    if (planData?.length) {
        planData.forEach((ele) => {
            if (Number(ele?.ProductCode) === Number(fgProductCode)) {
                Storage.set(
                    "FgPredefinedPlanData",
                    JSON.stringify(ele.PreDefinedBundle),
                    true
                );
                // Storage.set("FgPredefinedPlanData", response.data.PreDefinedBundles, true);
                Storage.set("FgProductCode", fgProductCode, true);
                if (ele.PreDefinedBundle?.length) {
                    for (let plan of ele.PreDefinedBundle) {
                        if (Number(plan.ID) === Number(storage_params["bundle_id"])) {
                            let data = {
                                plan_ids: storage_params["plan_ids"],
                                product_code: fgProductCode,
                                promotion_codes: ""
                            }
                            Storage.set(
                                "FgSelectedPlanData",
                                JSON.stringify(plan),
                                true
                            );
                            let sixAvailablePromotions = Plans.getAvailableSixPromotions(plan.Promotions);
                            if (sixAvailablePromotions) {
                                Storage.set("StreamModal",
                                    {
                                        'SHOW': true,
                                        'TYPE': "SAVE_PREDEFINED_FG",
                                        'PLAN': data,
                                        [variables.ANGHAMI_PROMOTION]: sixAvailablePromotions[variables.ANGHAMI_PROMOTION],
                                        [variables.STARZPLAY_PROMOTION]: sixAvailablePromotions[variables.STARZPLAY_PROMOTION],
                                        [variables.OSN_PROMOTION]: sixAvailablePromotions[variables.OSN_PROMOTION],
                                        [variables.UFC_PROMOTION]: sixAvailablePromotions[variables.UFC_PROMOTION],
                                        [variables.DISCOVERY_PROMOTION]: sixAvailablePromotions[variables.DISCOVERY_PROMOTION],
                                        [variables.BLUTV_PROMOTION]: sixAvailablePromotions[variables.BLUTV_PROMOTION],
                                    });
                            } else {
                                Storage.set("is_web_category_selected", true, true);
                                Storage.set("choose_plan_category", true, true);
                                Storage.set("is_category_type_5g", true, true);
                                Storage.set("wp_save_plan", true);
                                planFG.saveFGplan(data)
                                    .then(response => {
                                        User.fetchFlowStatus(4).then(response => {
                                            Storage.set("wp_loader", false);
                                        }).catch(res =>
                                            Storage.set("wp_loader", false)
                                        )
                                    }).catch(res => { Storage.set("wp_loader", false) })
                            }
                        }
                    }

                }

            }
        })
    }
};


planFG.saveFGplanData = (data, promotion_codes = null) => {
    let offerAppliedPromoId = Storage.get("offer_applied_promotion_id", true);
    // let storageId = Storage.get("promotionCodes")
    if (offerAppliedPromoId?.length) {
        // let promotionID = offerAppliedPromoId.join(",");
        // let promotionID = "";
        let config = {
            method: "post",
            url: "/plans/saved_plans",
            data: {
                plan_ids: data?.plan_ids,
                product_code: data?.product_code,
                promotion_codes: promotion_codes,
                is_5g: true
            }
        };
        return HTTP(config);
    } else {
        let config = {
            method: "post",
            url: "/plans/saved_plans",
            data: {
                plan_ids: data?.plan_ids,
                product_code: data?.product_code,
                promotion_codes: promotion_codes,
                is_5g: true
            },
            headers: {
                "cache-control": "no-cache"
            }
        };
        return HTTP(config);
    }

};

planFG.convertValdityToMonth = (duration) => {
    if (duration <= 45)
        return 1;
    const durationCutOff = duration - 15;
    if (durationCutOff % 30 === 0) {
        return durationCutOff / 30;
    } else {
        return parseInt(durationCutOff / 30 + 1);
    }
}

planFG.planModified = (PreDefinedBundles, active_product_Code, defaultCommittment) => {
    let groupedBundles = [];
    let availableMonths = [];
    if (PreDefinedBundles?.length) {
        PreDefinedBundles.forEach((plan_item) => {
            if (plan_item.ProductCode === active_product_Code) {

                if (plan_item?.PreDefinedBundle?.length) {
                    plan_item.PreDefinedBundle.forEach(bundle => {
                        const validity = bundle.Plan[0].Validity;
                        const month = planFG.convertValdityToMonth(validity) // Assuming each month has 30 days
                        let foundBundle = groupedBundles.find(group => group.month === month);
                        if (foundBundle) {
                            foundBundle.PreDefinedBundle.push(bundle);
                        } else {
                            groupedBundles.push({
                                PreDefinedBundle: [bundle],
                                month: month,
                                ProductCode: active_product_Code
                            });
                            availableMonths.push({
                                month: month,
                                CommitmentDuration: month * defaultCommittment,
                                commitment: defaultCommittment
                            });
                        }
                    });
                }
            }
        })
        availableMonths.sort((a, b) => (a.CommitmentDuration > b.CommitmentDuration) ? 1 : -1);
    }

    return { "groupedBundles": groupedBundles, "availableMonths": availableMonths }

    // let uniqueMonths = availableMonths.filter((item, i, ar) => ar.indexOf(item) === i)

}

planFG.monthsFromDays = (validitySelf) => {
    let business = Storage.get("business", true);
    let show_commitments_tabs_from_validity = null;
    if (business) {
        business = JSON.parse(business);
        show_commitments_tabs_from_validity = business?.show_commitments_tabs_from_validity;
    }
    if (show_commitments_tabs_from_validity) {
        return parseInt(validitySelf)
    } else {
        return parseInt((+validitySelf + 29) / 30)  // Adding 29 ensures rounding up for partial months
    }
}
planFG.checkValidity = (validityList) => {
    const KeyType = "Type";
    // Get typeValue from PO - ensure fallback is used if PO doesn't return anything useful
    let typeValues = Helpers.getPOValue("default_plan_type_for_calculating_validity", ["DATA"]);
    // Normalize to array (if not already)
    if (!Array.isArray(typeValues)) {
        typeValues = [typeValues];
    }
    let validityDays = "";
    if (Array.isArray(validityList) && validityList.length) {
        for (let type of typeValues) {
            for (let item of validityList) {
                if (item?.[KeyType] === type) {
                    validityDays = planFG.monthsFromDays(item.Validity);
                    return validityDays; // Return immediately on first match
                }
            }
        }
    }
    return validityDays; // Returns empty string if no match found
}
planFG.checkValiditySummaryInfo = (validityList) => {
    const KeyType = "Type";
    // Get typeValue from PO - ensure fallback is used if PO doesn't return anything useful
    let typeValues = Helpers.getPOValue("default_plan_type_for_calculating_validity", ["DATA"]);
    // Normalize to array (if not already)
    if (!Array.isArray(typeValues)) {
        typeValues = [typeValues];
    }
    let validityDays = "";
    if (Array.isArray(validityList) && validityList.length) {
        for (let type of typeValues) {
            for (let item of validityList) {
                if (item?.[KeyType] === type) {
                    validityDays = item?.Validity;
                    return validityDays; // Return immediately on first match
                }
            }
        }
    }
    return validityDays; // Returns empty string if no match found
}


planFG.checkValiditySummary = (summaryData = {}) => {
    let translationString = "";
    let sD = summaryData?.saved_plans?.[0]?.Plans;
    if (!sD?.length) {
      return "";  // early return if no plans
    }
    if(planFG.checkValidity(sD) !== 0) {
        translationString = `commitment_tab_${summaryData?.plan_commitment_period}_duration_${planFG.checkValiditySummaryInfo(sD)}_product_code_${summaryData?.saved_plans?.[0]?.ProductCode || 1}`
    }
    return translationString;
};

planFG.getCommitment = (commitmentList, productCode) => {
    let commitmentDays = "";
    let allowFeature = "";
    let CommitmentDiscountPercent = "";
    if (commitmentList?.length) {
        commitmentList.forEach((item) => {
            if (item?.ProductCode === productCode) {
                commitmentDays = item?.CommitmentDuration;
                allowFeature = item?.AllowedFeatures
                CommitmentDiscountPercent = item?.CommitmentDiscountPercent;
            }
        })
    }
    return { "commitment": commitmentDays, "allowFeature": allowFeature, "CommitmentDiscountPercent": CommitmentDiscountPercent }
}

planFG.plandataModified = (PreDefinedBundles, list) => {
    let groupedBundles = [];
    let availableMonths = [];
    if (PreDefinedBundles) {
        PreDefinedBundles.forEach((plan_item) => {
            if (plan_item.ProductCode) {
                if (plan_item?.PreDefinedBundle?.length) {
                    plan_item.PreDefinedBundle.forEach(bundle => {
                        const validity = planFG.checkValidity(bundle.Plan);
                        const { commitment, allowFeature, CommitmentDiscountPercent } = planFG.getCommitment(list, plan_item?.ProductCode);

                        let foundBundle = groupedBundles.find(group => group?.validity === validity &&
                            group?.ProductCode === plan_item?.ProductCode
                        );
                        if (foundBundle) {
                            foundBundle.PreDefinedBundle.push(bundle);
                        } else if (validity !== null) {
                            groupedBundles.push({
                                PreDefinedBundle: [bundle],
                                validity: validity,
                                ProductCode: plan_item.ProductCode,
                                month: validity,
                                commitment: commitment,
                                allowFeature: allowFeature, 
                                CommitmentDiscountPercent: CommitmentDiscountPercent
                            });
                            availableMonths.push({
                                validity: validity,
                                month: validity,
                                ProductCode: plan_item.ProductCode,
                                commitment: commitment,
                                allowFeature: allowFeature,
                                CommitmentDiscountPercent: CommitmentDiscountPercent
                            });
                        }
                    });
                }
            }
        })
        availableMonths.sort((a, b) => (a.CommitmentDuration > b.CommitmentDuration) ? 1 : -1);
    }

    return { "groupedBundles": groupedBundles, "availableMonths": availableMonths }

    // let uniqueMonths = availableMonths.filter((item, i, ar) => ar.indexOf(item) === i)

}

planFG.checkValidityByType = (validity, typeValue) => {
    let validityType = "RenewableBundle";
    let validityDays = null;
    if (validityType === typeValue) {
        validityDays = validity

    }
    return validityDays
}

planFG.customPlandataModified = (customPlan, list) => {
    let groupedBundles = [];
    let availableMonths = [];
    if (customPlan?.length) {
        customPlan.forEach((plan_item) => {
            if (plan_item.ProductCode) {
                if (plan_item?.AvailablePlans?.length) {
                    let zeroGroupedBundles = plan_item.AvailablePlans.find(group => +group?.Validity === 0 &&
                        STF_CONSTANTS.VALIDITY_TYPE.includes(group?.ChargingType)
                    );
                   
                    plan_item.AvailablePlans.forEach(bundle => {
                        const validity = +bundle?.Validity !== 0 ? planFG.monthsFromDays(bundle?.Validity) : null;
                        const commitment = planFG.getCommitment(list, plan_item?.ProductCode);

                        let foundBundle = groupedBundles.find(group => group?.validity === validity &&
                            group?.ProductCode === plan_item?.ProductCode
                        );
                        if (foundBundle) {
                            foundBundle.AvailablePlans.push(bundle);
                        }
                        else if (validity !== null) {
                            groupedBundles.push({
                                AvailablePlans: isPlanKw ? [bundle, zeroGroupedBundles]: [bundle],
                                validity: validity,
                                ProductCode: plan_item?.ProductCode,
                                commitment: commitment,
                                PackagesPricingTable: plan_item?.PackagesPricingTable
                            });
                            // groupedBundles.push({
                            //     AvailablePlans: [zeroGroupedBundles],
                            //     validity: 0,
                            //     ProductCode: plan_item?.ProductCode,
                            //     commitment: commitment,
                            //     PackagesPricingTable: plan_item?.PackagesPricingTable
                            // });
                            availableMonths.push({
                                validity: validity,
                                month: validity,
                                ProductCode: plan_item.ProductCode,
                                commitment: commitment,
                                PackagesPricingTable: plan_item?.PackagesPricingTable
                            });
                        }
                    });
                }
            }
        })
        availableMonths.sort((a, b) => (a.CommitmentDuration > b.CommitmentDuration) ? 1 : -1);
    }

    return { "groupedBundles": groupedBundles, "availableMonths": availableMonths }

    // let uniqueMonths = availableMonths.filter((item, i, ar) => ar.indexOf(item) === i)

}

export default planFG;